import type { ReactElement } from 'react';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import AuthContext from '../../context/AuthContext';
import Header from '../../modules/Header';

import styles from './BasicLayout.module.scss';

/**
 * Базовая layout-оболочка авторизованной зоны survey-client.
 * Рендерит перенесённый Header и вложенный route outlet.
 *
 * @returns {ReactElement}
 */
export function BasicLayout(): ReactElement {
  const { kToken } = useContext(AuthContext);

  return (
    <div className={styles.root}>
      <Header type='page' user={typeof kToken === 'string'} />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}

export default BasicLayout;
